namespace GeniuzPOS.Member {
    export class ReportMemberConditionColumns {
        static columnsKey = 'Member.ReportMemberCondition';
    }
}
